import { useEffect, useState, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import DriverApi from "../../../Services/Driver";
import RegisterApi from "../../../Services/Register";
import Header from "../../../components/header";
import Footer from "../../../components/footer";
import { showSnackbar } from "Redux/SnackBar/actions";
import { showLoader, hideLoader } from "Redux/Loader/actions";
import "./mPlusProgram.css";
import { useIntl } from "react-intl";

const stepLabels = [
  { number: 1, key: "1" },
  { number: 2, key: "2" },
  { number: 3, key: "3" },
  { number: 4, key: "4" },
  { number: 5, key: "5" },
];

const regionOptions = [
  { value: "Douala", labelKey: "mplus.region.douala" },
  { value: "Yaoundé", labelKey: "mplus.region.yaounde" },
  { value: "Bafoussam", labelKey: "mplus.region.bafoussam" },
  { value: "Bamenda", labelKey: "mplus.region.bamenda" },
  { value: "Autre", labelKey: "mplus.region.other" },
];

const relationshipOptions = [
  { value: "FATHER", labelKey: "mplus.relationship.father" },
  { value: "MOTHER", labelKey: "mplus.relationship.mother" },
  { value: "SPOUSE", labelKey: "mplus.relationship.spouse" },
  { value: "BROTHER", labelKey: "mplus.relationship.brother" },
  { value: "SISTER", labelKey: "mplus.relationship.sister" },
  { value: "SON", labelKey: "mplus.relationship.son" },
  { value: "DAUGHTER", labelKey: "mplus.relationship.daughter" },
  { value: "FRIEND", labelKey: "mplus.relationship.friend" },
  { value: "GUARDIAN", labelKey: "mplus.relationship.guardian" },
  { value: "RELATIVE", labelKey: "mplus.relationship.relative" },
  { value: "OTHER", labelKey: "mplus.relationship.other" },
];

const vehicleRequestOptions = [
  { value: "MOTORCYCLE", labelKey: "mplus.vehicle.motorcycle", icon: MotorcycleClassIcon },
  { value: "STANDARD_TAXI_CAR", labelKey: "mplus.vehicle.standardTaxi", icon: TaxiClassIcon },
];

const vehicleTypeByVehicleRequested = {
  MOTORCYCLE: "MOTORCYCLE",
  STANDARD_TAXI_CAR: "CAR",
  TRICYCLE: "TRICYCLE",
};

const vehicleRequestedByTaxiType = {
  MOTORCYCLE: "MOTORCYCLE",
  CAR: "STANDARD_TAXI_CAR",
  TRICYCLE: "TRICYCLE",
};

const repaymentOptions = [
  { value: "12", labelKey: "mplus.repayment.12" },
  { value: "18", labelKey: "mplus.repayment.18" },
  { value: "24", labelKey: "mplus.repayment.24" },
  { value: "36", labelKey: "mplus.repayment.36" },
];


const stepIntroEditorialContent = {
  1: {
    eyebrowKeys: ["mplus.intro.eyebrow.step1", "mplus.intro.eyebrowSub.step1"],
    titleKeys: ["mplus.intro.title.step1.line1", "mplus.intro.title.step1.line2"],
    accentLastLine: true,
    summaryKey: "mplus.intro.summary.step1",
    items: [
      { titleKey: "mplus.intro.item1.title.step1", textKey: "mplus.intro.item1.text.step1", icon: UserIcon },
      { titleKey: "mplus.intro.item2.title.step1", textKey: "mplus.intro.item2.text.step1", icon: ShieldFeatureIcon },
      { titleKey: "mplus.intro.item3.title.step1", textKey: "mplus.intro.item3.text.step1", icon: ArrowRightIcon },
    ],
  },
  2: {
    eyebrowKeys: ["mplus.intro.eyebrow.step2", "mplus.intro.eyebrowSub.step2"],
    titleKeys: ["mplus.intro.title.step2.line1", "mplus.intro.title.step2.line2"],
    summaryKey: "mplus.intro.summary.step2",
    items: [
      { titleKey: "mplus.intro.item1.title.step2", textKey: "mplus.intro.item1.text.step2", icon: CheckIcon },
      { titleKey: "mplus.intro.item2.title.step2", textKey: "mplus.intro.item2.text.step2", icon: CarFeatureIcon },
      { titleKey: "mplus.intro.item3.title.step2", textKey: "mplus.intro.item3.text.step2", icon: ArrowRightIcon },
    ],
  },
  3: {
    eyebrowKeys: ["mplus.intro.eyebrow.step3", "mplus.intro.eyebrowSub.step3"],
    titleKeys: ["mplus.intro.title.step3.line1", "mplus.intro.title.step3.line2"],
    summaryKey: "mplus.intro.summary.step3",
    items: [
      { titleKey: "mplus.intro.item1.title.step3", textKey: "mplus.intro.item1.text.step3", icon: CarFeatureIcon },
      { titleKey: "mplus.intro.item2.title.step3", textKey: "mplus.intro.item2.text.step3", icon: CheckIcon },
      { titleKey: "mplus.intro.item3.title.step3", textKey: "mplus.intro.item3.text.step3", icon: ShieldFeatureIcon },
    ],
  },
  4: {
    eyebrowKeys: ["mplus.intro.eyebrow.step4", "mplus.intro.eyebrowSub.step4"],
    titleKeys: ["mplus.intro.title.step4.line1", "mplus.intro.title.step4.line2"],
    summaryKey: "mplus.intro.summary.step4",
    items: [
      { titleKey: "mplus.intro.item1.title.step4", textKey: "mplus.intro.item1.text.step4", icon: UserIcon },
      { titleKey: "mplus.intro.item2.title.step4", textKey: "mplus.intro.item2.text.step4", icon: PaperclipIcon },
      { titleKey: "mplus.intro.item3.title.step4", textKey: "mplus.intro.item3.text.step4", icon: ShieldFeatureIcon },
    ],
  },
  5: {
    eyebrowKeys: ["mplus.intro.eyebrow.step5", "mplus.intro.eyebrowSub.step5"],
    titleKeys: ["mplus.intro.title.step5.line1", "mplus.intro.title.step5.line2"],
    summaryKey: "mplus.intro.summary.step5",
    items: [
      { titleKey: "mplus.intro.item1.title.step5", textKey: "mplus.intro.item1.text.step5", icon: CheckIcon },
      { titleKey: "mplus.intro.item2.title.step5", textKey: "mplus.intro.item2.text.step5", icon: ShieldFeatureIcon },
      { titleKey: "mplus.intro.item3.title.step5", textKey: "mplus.intro.item3.text.step5", icon: ArrowRightIcon },
    ],
  },
};

const documentUploadHintKey = "mplus.document.hint";

const maxFileSize = 5 * 1024 * 1024;

function getStepStatus(currentStep, stepNumber) {
  if (currentStep > stepNumber) {
    return "complete";
  }

  if (currentStep === stepNumber) {
    return "active";
  }

  return "upcoming";
}

function appendIfPresent(formData, key, value) {
  if (value === undefined || value === null || value === "") {
    return;
  }

  formData.append(key, value);
}

function normalizeDateDisplay(value) {
  if (!value) {
    return "";
  }

  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [year, month, day] = value.split("-");
    return `${day}/${month}/${year}`;
  }

  return value;
}

function toDateInputValue(value) {
  if (!value) {
    return "";
  }

  return String(value).slice(0, 10);
}

function getDisplayValue(intl, value) {
  return value || intl.formatMessage({ id: "mplus.noData" });
}

function getOptionLabel(intl, options, value) {
  const option = options.find((o) => o.value === value);
  if (!option) return value;
  return option.labelKey ? intl.formatMessage({ id: option.labelKey }) : option.label || value;
}

function CheckIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M9.2 16.2 4.9 11.9l-1.4 1.4 5.7 5.7L20.5 7.7l-1.4-1.4z" />
    </svg>
  );
}

function ArrowRightIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="m10 4 8 8-8 8-1.4-1.4 5.6-5.6H4v-2h10.2l-5.6-5.6z" />
    </svg>
  );
}

function ArrowLeftIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M14 4 5.7 12 14 20l1.4-1.4-5.6-5.6H20v-2H9.8l5.6-5.6z" />
    </svg>
  );
}

function UserIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M12 12.1a4.7 4.7 0 1 0-4.7-4.7 4.7 4.7 0 0 0 4.7 4.7zm0 2.2c-4.2 0-7.6 2.3-7.6 5.1V21h15.2v-1.6c0-2.8-3.4-5.1-7.6-5.1z" />
    </svg>
  );
}

function CalendarIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M7 2.5h2v2h6v-2h2v2h2.2A2.3 2.3 0 0 1 21.5 6.8v12a2.3 2.3 0 0 1-2.3 2.3H4.8a2.3 2.3 0 0 1-2.3-2.3v-12A2.3 2.3 0 0 1 4.8 4.5H7zm12.4 7.1H4.6v9.1h14.8z" />
    </svg>
  );
}

function ChevronDownIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="m12 15.4-6-6 1.4-1.4 4.6 4.6 4.6-4.6 1.4 1.4z" />
    </svg>
  );
}

function PaperclipIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M16.8 7.5 10 14.3a3.1 3.1 0 0 0 4.4 4.4l6.4-6.4a5.3 5.3 0 1 0-7.5-7.5L6 12.5a7.5 7.5 0 0 0 10.6 10.6l5.7-5.7-1.4-1.4-5.7 5.7a5.5 5.5 0 0 1-7.8-7.8l7.8-7.8a3.2 3.2 0 1 1 4.6 4.6l-6.4 6.4a1.1 1.1 0 0 1-1.5-1.5l6.8-6.8z" />
    </svg>
  );
}

function MotorcycleClassIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="6.3" cy="17.1" r="2.2" />
      <circle cx="17.7" cy="17.1" r="2.2" />
      <path d="M8 16.7h2.8l1.8-3.7h2.2l1.9 2" />
      <path d="M10.8 13h2.5l1 1.8" />
      <path d="M13.5 10.4h1.8l1 1.4" />
      <path d="M9.3 9.6h1.7l1 1.7" />
    </svg>
  );
}

function TaxiClassIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M5.1 15.5 6.3 11a2.2 2.2 0 0 1 2.1-1.6h7.2a2.2 2.2 0 0 1 2.1 1.6l1.3 4.5" />
      <path d="M4.6 15.5h14.8" />
      <circle cx="6.7" cy="17.9" r="1.4" />
      <circle cx="17.3" cy="17.9" r="1.4" />
      <path d="M8.9 9.5h6.2l.8-1.4H8.2z" />
      <path d="M11 8.1h2v1.4h-2z" />
    </svg>
  );
}

function CarFeatureIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M5.5 14.1h13l1.4 2.7v3.7h-2.2v-1.4H6.3v1.4H4v-3.7zm2.2-5.8h8.1l1.7 4H6zM7 19.1a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4zm10 0a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4z" />
    </svg>
  );
}

function ShieldFeatureIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M12 2.5 4 5.7v5.1c0 5 3.2 8.9 8 10.7 4.8-1.8 8-5.7 8-10.7V5.7zM11 12.6l5.2-5.2 1.4 1.4L11 15.4 7.4 11.8l1.4-1.4z" />
    </svg>
  );
}

function Stepper({ currentStep, t }) {
  const progress = Math.min(
    Math.max(((currentStep - 0.5) / stepLabels.length) * 100, 12.5),
    87.5,
  );

  return (
    <div className="driver-signup-stepper" style={{ "--step-progress": `${progress}%` }}>
      {stepLabels.map((step) => {
        const status = getStepStatus(currentStep, step.number);

        return (
          <div key={step.number} className={`driver-signup-step is-${status}`}>
            <span className="driver-signup-step__dot" aria-hidden="true">
              {status === "complete" ? <CheckIcon /> : step.number}
            </span>
            <div className="driver-signup-step__label">
              <span>{t(`mplus.step.label${step.number}.line1`)}</span>
              <span>{t(`mplus.step.label${step.number}.line2`)}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
}

function FeatureList({ items, t }) {
  return (
    <div className="driver-signup-features">
      {items.map((feature) => {
        const Icon = feature.icon;

        return (
          <div className="driver-signup-feature" key={feature.titleKey}>
            <span className="driver-signup-feature__icon" aria-hidden="true">
              <Icon />
            </span>
            <div>
              <h3>{t(feature.titleKey)}</h3>
              <p>{t(feature.textKey)}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}

function StepIntroPanel({ currentStep, t }) {
  const content = stepIntroEditorialContent[currentStep] || stepIntroEditorialContent[4];

  return (
    <div className="driver-signup-intro">
      <div className="driver-signup-intro__eyebrow">
        {content.eyebrowKeys.map((key) => (
          <span key={key}>{t(key)}</span>
        ))}
      </div>
      <h2 className="driver-signup-intro__title">
        {content.titleKeys.map((key, index) => {
          const isAccent =
            content.accentLastLine && index === content.titleKeys.length - 1;

          return (
            <span key={key} className={isAccent ? "is-accent" : ""}>
              {t(key)}
            </span>
          );
        })}
      </h2>
      <p className="driver-signup-intro__summary">{t(content.summaryKey)}</p>
      <div className="driver-signup-intro__divider" aria-hidden="true" />
      <FeatureList items={content.items} t={t} />
    </div>
  );
}

function RequiredLabel({ children }) {
  return (
    <span className="driver-signup-required-label">
      {children}
      <span aria-hidden="true" className="driver-signup-required-label__asterisk">
        *
      </span>
    </span>
  );
}

function LabeledInput({
  label,
  required,
  value,
  onChange,
  onBlur,
  placeholder,
  type = "text",
  name,
  error,
  trailingIcon: TrailingIcon,
  autoComplete,
  inputMode,
  as = "input",
  rows = 3,
  className = "",
  disabled = false,
}) {
  const showTrailingIcon = Boolean(TrailingIcon) && type !== "date";

  return (
    <label className={`driver-signup-control ${className}`.trim()}>
      <span className="driver-signup-control__label">
        {required ? <RequiredLabel>{label}</RequiredLabel> : label}
      </span>
      <div
        className={`driver-signup-field driver-signup-field--labelled${showTrailingIcon ? " driver-signup-field--has-trailing" : ""}${error ? " is-error" : ""}`.trim()}
      >
        {as === "textarea" ? (
          <textarea
            name={name}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            placeholder={placeholder}
            rows={rows}
            aria-invalid={error ? "true" : "false"}
            disabled={disabled}
          />
        ) : (
          <input
            name={name}
            type={type}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            placeholder={placeholder}
            autoComplete={autoComplete}
            inputMode={inputMode}
            aria-invalid={error ? "true" : "false"}
            disabled={disabled}
          />
        )}

        {showTrailingIcon ? (
          <span className="driver-signup-field__trailing" aria-hidden="true">
            <TrailingIcon />
          </span>
        ) : null}
      </div>
    </label>
  );
}

function SelectField({
  label,
  required,
  value,
  onChange,
  name,
  error,
  children,
  className = "",
}) {
  return (
    <label className={`driver-signup-control ${className}`.trim()}>
      <span className="driver-signup-control__label">
        {required ? <RequiredLabel>{label}</RequiredLabel> : label}
      </span>
      <div
        className={`driver-signup-field driver-signup-field--labelled driver-signup-field--select${error ? " is-error" : ""}`.trim()}
      >
        <select
          name={name}
          value={value}
          onChange={onChange}
          required={required}
          aria-invalid={error ? "true" : "false"}
        >
          {children}
        </select>
        <span className="driver-signup-field__trailing" aria-hidden="true">
          <ChevronDownIcon />
        </span>
      </div>
    </label>
  );
}

function RadioOption({ name, value, label, icon: Icon, checked, onChange }) {
  return (
    <label className="driver-signup-radio">
      <input type="radio" name={name} value={value} checked={checked} onChange={onChange} />
      <span className="driver-signup-radio__mark" aria-hidden="true">
        <span />
      </span>
      <span className="driver-signup-radio__text">
        {Icon ? (
          <span className="driver-signup-radio__icon" aria-hidden="true">
            <Icon />
          </span>
        ) : null}
        <span>{label}</span>
      </span>
    </label>
  );
}

function ChoiceCard({ name, value, label, icon: Icon, checked, onChange }) {
  return (
    <label className={`driver-signup-choice-card${checked ? " is-selected" : ""}`}>
      <input type="radio" name={name} value={value} checked={checked} onChange={onChange} />
      <span className="driver-signup-choice-card__icon" aria-hidden="true">
        {Icon ? <Icon /> : null}
      </span>
      <span className="driver-signup-choice-card__label">{label}</span>
    </label>
  );
}

function InfoIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M12 2.5A9.5 9.5 0 1 0 21.5 12 9.5 9.5 0 0 0 12 2.5zm0 4a1.2 1.2 0 1 1-1.2 1.2A1.2 1.2 0 0 1 12 6.5zm1.3 11h-2.6v-1.8h.4V11h-.4V9.2h2.2V15h.4z" />
    </svg>
  );
}

function SpinnerIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      className="driver-signup-spinner"
    >
      <circle cx="12" cy="12" r="9" opacity="0.25" />
      <path d="M21 12a9 9 0 0 0-9-9" />
    </svg>
  );
}

function ErrorIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M12 2.5 2.5 20.5h19zM12 9.2a1 1 0 0 1 1 1v4.6a1 1 0 0 1-2 0V10.2a1 1 0 0 1 1-1zm0 8.6a1.2 1.2 0 1 1 0 2.4 1.2 1.2 0 0 1 0-2.4z" />
    </svg>
  );
}

function FileUploadField({
  label,
  hint,
  file,
  onChange,
  error,
  name,
  t,
}) {
  const [previewUrl, setPreviewUrl] = useState("");

  useEffect(() => {
    if (!file) {
      setPreviewUrl("");
      return undefined;
    }

    const nextPreviewUrl = URL.createObjectURL(file);
    setPreviewUrl(nextPreviewUrl);

    return () => {
      URL.revokeObjectURL(nextPreviewUrl);
    };
  }, [file]);

  return (
    <div className="driver-signup-upload">
      <span className="driver-signup-upload__label">
        {label}
        <span aria-hidden="true" className="driver-signup-required-label__asterisk">
          *
        </span>
      </span>
      <label className={`driver-signup-upload__button${error ? " is-error" : ""}`}>
        <input
          className="driver-signup-upload__input"
          type="file"
          name={name}
          accept=".jpg,.jpeg,.png,.pdf"
          onChange={onChange}
        />
        <span className="driver-signup-upload__icon" aria-hidden="true">
          <PaperclipIcon />
        </span>
        <span className="driver-signup-upload__copy">
          <strong>{t("mplus.upload.attachFile")}</strong>
          <span>{hint}</span>
        </span>
      </label>
      {file ? (
        <div className="driver-signup-upload__meta">
          <span className="driver-signup-upload__filename">{file.name}</span>
          {previewUrl ? (
            <button
              type="button"
              className="driver-signup-upload__preview"
              onClick={() => window.open(previewUrl, "_blank", "noopener,noreferrer")}
            >
              {t("mplus.upload.preview")}
            </button>
          ) : null}
        </div>
      ) : null}
      {error ? <p className="driver-signup-error">{error}</p> : null}
    </div>
  );
}

function ChecklistBox({ title = "Documents attached", items, values }) {
  return (
    <div className="driver-signup-checklist">
      <h4 className="driver-signup-checklist__title">{title}</h4>
      <div className="driver-signup-checklist__items">
        {items.map((item) => {
          return (
            <label key={item.id} className="driver-signup-check">
              <input
                type="checkbox"
                checked={Boolean(values[item.id])}
                disabled
                aria-disabled="true"
              />
              <span className="driver-signup-check__box" aria-hidden="true">
                <CheckIcon />
              </span>
              <span>{item.label}</span>
            </label>
          );
        })}
      </div>
    </div>
  );
}

function SummaryPanel({ form, intl, t }) {
  const leftItems = [
    { label: t("mplus.summary.name"), value: form.fullName },
    { label: t("mplus.summary.accountId"), value: form.accountId },
    { label: t("mplus.summary.phone"), value: form.phone },
    { label: t("mplus.summary.region"), value: form.region },
    { label: t("mplus.summary.drivingStartDate"), value: normalizeDateDisplay(form.drivingStartDate) },
    { label: t("mplus.summary.vehicleRequested"), value: getOptionLabel(intl, vehicleRequestOptions, form.vehicleRequested) },
    { label: t("mplus.summary.repayment"), value: getOptionLabel(intl, repaymentOptions, form.repaymentPreference) },
    { label: t("mplus.summary.guarantor"), value: form.guarantorFullName },
    { label: t("mplus.summary.guarantorRelationship"), value: getOptionLabel(intl, relationshipOptions, form.guarantorRelationship) },
    { label: t("mplus.summary.guarantorAddress"), value: form.guarantorAddress },
  ];

  const rightItems = [
    { label: t("mplus.summary.email"), value: form.email },
    { label: t("mplus.summary.address"), value: form.address },
    { label: t("mplus.summary.monthsActive"), value: form.monthsActive },
    { label: t("mplus.summary.rideAcceptanceRate"), value: `${getDisplayValue(intl, form.rideAcceptanceRate)}%` },
    { label: t("mplus.summary.cancellationRate"), value: `${getDisplayValue(intl, form.cancellationRate)}%` },
    { label: t("mplus.summary.averageWeeklyTrips"), value: form.averageWeeklyTrips },
    { label: t("mplus.summary.nationalId"), value: form.nationalIdNumber },
    { label: t("mplus.summary.driverLicense"), value: form.driverLicenseNumber },
    { label: t("mplus.summary.licenseExpiry"), value: normalizeDateDisplay(form.licenseExpiryDate) },
    { label: t("mplus.summary.guarantorPhone"), value: form.guarantorPhoneNumber },
    { label: t("mplus.summary.guarantorNationalId"), value: form.guarantorNationalId },
  ];

  return (
    <div className="driver-signup-summary">
      <div className="driver-signup-summary__column">
        {leftItems.map((item) => (
          <div key={item.label} className="driver-signup-summary__item">
            <span className="driver-signup-summary__label">{item.label} :</span>
            <span className="driver-signup-summary__value">{getDisplayValue(intl, item.value)}</span>
          </div>
        ))}
      </div>

      <div className="driver-signup-summary__column">
        {rightItems.map((item) => (
          <div key={item.label} className="driver-signup-summary__item">
            <span className="driver-signup-summary__label">{item.label} :</span>
            <span className="driver-signup-summary__value">{getDisplayValue(intl, item.value)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

function validateStepOne(intl, form) {
  const nextErrors = {};
  if (!form.fullName.trim()) nextErrors.fullName = intl.formatMessage({ id: "mplus.error.fullName" });
  if (!form.accountId.trim()) nextErrors.accountId = intl.formatMessage({ id: "mplus.error.accountId" });
  if (!form.email.trim()) nextErrors.email = intl.formatMessage({ id: "mplus.error.email" });
  if (!form.phone.trim()) nextErrors.phone = intl.formatMessage({ id: "mplus.error.phone" });
  if (!form.region.trim()) nextErrors.region = intl.formatMessage({ id: "mplus.error.region" });
  if (!form.address.trim()) nextErrors.address = intl.formatMessage({ id: "mplus.error.address" });
  return nextErrors;
}

function validateStepTwo(intl, form) {
  const nextErrors = {};
  if (!form.drivingStartDate.trim()) nextErrors.drivingStartDate = intl.formatMessage({ id: "mplus.error.drivingStartDate" });
  if (!form.monthsActive.trim()) nextErrors.monthsActive = intl.formatMessage({ id: "mplus.error.monthsActive" });
  if (!form.rideAcceptanceRate.trim()) {
    nextErrors.rideAcceptanceRate = intl.formatMessage({ id: "mplus.error.rideAcceptanceRate" });
  } else if (Number(form.rideAcceptanceRate) < 90) {
    nextErrors.rideAcceptanceRate = intl.formatMessage({ id: "mplus.error.rideAcceptanceRateMin" });
  }
  if (!form.cancellationRate.trim()) {
    nextErrors.cancellationRate = intl.formatMessage({ id: "mplus.error.cancellationRate" });
  } else if (Number(form.cancellationRate) > 5) {
    nextErrors.cancellationRate = intl.formatMessage({ id: "mplus.error.cancellationRateMax" });
  }
  if (!form.averageWeeklyTrips.trim()) nextErrors.averageWeeklyTrips = intl.formatMessage({ id: "mplus.error.averageWeeklyTrips" });
  return nextErrors;
}

function validateStepThree(intl, form) {
  const nextErrors = {};
  if (!form.vehicleRequested.trim()) nextErrors.vehicleRequested = intl.formatMessage({ id: "mplus.error.vehicleRequested" });
  if (!form.repaymentPreference.trim()) nextErrors.repaymentPreference = intl.formatMessage({ id: "mplus.error.repaymentPreference" });
  if (!form.nationalIdNumber.trim()) nextErrors.nationalIdNumber = intl.formatMessage({ id: "mplus.error.nationalIdNumber" });
  if (!form.driverLicenseNumber.trim()) nextErrors.driverLicenseNumber = intl.formatMessage({ id: "mplus.error.driverLicenseNumber" });
  if (!form.licenseExpiryDate.trim()) nextErrors.licenseExpiryDate = intl.formatMessage({ id: "mplus.error.licenseExpiryDate" });
  return nextErrors;
}

function validateStepFour(intl, form, documentTypes, documentFiles) {
  const nextErrors = {};
  if (!form.guarantorFullName.trim()) nextErrors.guarantorFullName = intl.formatMessage({ id: "mplus.error.guarantorFullName" });
  if (!form.guarantorRelationship.trim()) nextErrors.guarantorRelationship = intl.formatMessage({ id: "mplus.error.guarantorRelationship" });
  if (!form.guarantorPhoneNumber.trim()) nextErrors.guarantorPhoneNumber = intl.formatMessage({ id: "mplus.error.guarantorPhoneNumber" });
  if (!form.guarantorNationalId.trim()) nextErrors.guarantorNationalId = intl.formatMessage({ id: "mplus.error.guarantorNationalId" });
  if (!form.guarantorAddress.trim()) nextErrors.guarantorAddress = intl.formatMessage({ id: "mplus.error.guarantorAddress" });
  documentTypes.forEach((item) => {
    if (!documentFiles[item.id]) {
      nextErrors[item.id] = `${item.documentType} ${intl.formatMessage({ id: "mplus.error.docRequired" })}`;
    }
  });
  return nextErrors;
}

function validateStepFive(intl, form) {
  const nextErrors = {};
  if (!form.acceptDeclaration) nextErrors.acceptDeclaration = intl.formatMessage({ id: "mplus.error.acceptDeclaration" });
  return nextErrors;
}

export default function MPlusProgram() {
  const [currentStep, setCurrentStep] = useState(1);
  const [form, setForm] = useState({
    fullName: "",
    accountId: "",
    email: "",
    phone: "",
    region: "",
    address: "",
    drivingStartDate: "",
    monthsActive: "",
    rideAcceptanceRate: "",
    cancellationRate: "",
    averageWeeklyTrips: "",
    vehicleRequested: "",
    preferredMakeModel: "",
    preferredVehicleColor: "",
    repaymentPreference: "",
    nationalIdNumber: "",
    driverLicenseNumber: "",
    licenseExpiryDate: "",
    moralityCertificateReference: "",
    guarantorFullName: "",
    guarantorRelationship: "",
    guarantorPhoneNumber: "",
    guarantorNationalId: "",
    guarantorAddress: "",
    acceptDeclaration: false,
  });
  const [documentTypes, setDocumentTypes] = useState([]);
  const [documentTypesLoading, setDocumentTypesLoading] = useState(false);
  const [documentFiles, setDocumentFiles] = useState({});
  const [errors, setErrors] = useState({});
  const [uploadErrors, setUploadErrors] = useState({});
  const [codeVerified, setCodeVerified] = useState(false);
  const [codeLookupLoading, setCodeLookupLoading] = useState(false);
  const [codeLookupError, setCodeLookupError] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const intl = useIntl();
  const t = (id, values) => intl.formatMessage({ id }, values);
  const documentsChecklist = documentTypes.reduce((accumulator, item) => {
    accumulator[item.id] = Boolean(documentFiles[item.id]);
    return accumulator;
  }, {});

  useEffect(() => {
    let isMounted = true;
    setDocumentTypesLoading(true);

    DriverApi.getDocumentsTypesV2("PROGRAM")
      .then((res) => {
        if (!isMounted) return;
        const list = Array.isArray(res?.data?.data) ? res.data.data : [];
        setDocumentTypes(list);
      })
      .catch(() => {
        if (isMounted) setDocumentTypes([]);
      })
      .finally(() => {
        if (isMounted) setDocumentTypesLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, []);

  function updateField(field) {
    return (event) => {
      const value = event.target.value;
      setForm((current) => ({
        ...current,
        [field]: value,
      }));
    };
  }

  function handleRadioChange(field, value) {
    setForm((current) => ({
      ...current,
      [field]: value,
    }));
  }

  function handleAccountIdChange(event) {
    const value = event.target.value;

    setForm((current) => ({
      ...current,
      accountId: value,
    }));

    if (codeVerified) {
      setCodeVerified(false);
    }
    if (codeLookupError) {
      setCodeLookupError("");
    }
  }

  function handleAccountIdBlur() {
    const code = form.accountId.trim();

    if (!code) {
      setCodeVerified(false);
      setCodeLookupError("");
      return;
    }

    setCodeLookupLoading(true);
    setCodeLookupError("");

    RegisterApi.getUserInfoByCode(code)
      .then((res) => {
        const data = res?.data?.data;

        if (!res?.data?.success || !data) {
          setCodeVerified(false);
          setCodeLookupError(t("mplus.code.notFound"));
          return;
        }

        setForm((current) => ({
          ...current,
          fullName: data.name || current.fullName,
          phone: data.phone || current.phone,
          email: data.email || current.email,
          region: data.city || current.region,
          address: data.address || current.address,
          vehicleRequested:
            vehicleRequestedByTaxiType[data.taxi_type] || current.vehicleRequested,
          nationalIdNumber: data.cni_number || current.nationalIdNumber,
          driverLicenseNumber: data.driver_license_number || current.driverLicenseNumber,
          licenseExpiryDate:
            toDateInputValue(data.license_expiry_date) || current.licenseExpiryDate,
        }));
        setCodeVerified(true);
      })
      .catch((error) => {
        setCodeVerified(false);
        setCodeLookupError(
          error?.response?.data?.error ||
            error?.response?.data?.message ||
            t("mplus.code.error"),
        );
      })
      .finally(() => {
        setCodeLookupLoading(false);
      });
  }

  function handleDocumentFileChange(documentTypeId) {
    return (event) => {
      const file = event.target.files?.[0];

      if (!file) {
        return;
      }

      if (file.size > maxFileSize) {
        setUploadErrors((current) => ({
          ...current,
          [documentTypeId]: t("mplus.error.fileSize"),
        }));
        return;
      }

      setUploadErrors((current) => ({
        ...current,
        [documentTypeId]: "",
      }));

      setDocumentFiles((current) => ({
        ...current,
        [documentTypeId]: file,
      }));
    };
  }

  function goNext() {
    if (currentStep === 1 && !codeVerified) {
      return;
    }

    let nextErrors = {};

    if (currentStep === 1) {
      nextErrors = validateStepOne(intl, form);
    } else if (currentStep === 2) {
      nextErrors = validateStepTwo(intl, form);
    } else if (currentStep === 3) {
      nextErrors = validateStepThree(intl, form);
    } else if (currentStep === 4) {
      nextErrors = validateStepFour(intl, form, documentTypes, documentFiles);
    }

    setErrors(nextErrors);

    if (Object.keys(nextErrors).length > 0) {
      return;
    }

    setCurrentStep((current) => Math.min(current + 1, 5));
  }

  function goBack() {
    setErrors({});
    setCurrentStep((current) => Math.max(current - 1, 1));
  }

  async function handleSubmit(event) {
    event.preventDefault();

    const nextErrors = validateStepFive(intl, form);
    setErrors(nextErrors);

    if (Object.keys(nextErrors).length > 0) {
      return;
    }

    const applicationPayload = new FormData();

    appendIfPresent(applicationPayload, "code", form.accountId.trim());
    appendIfPresent(applicationPayload, "start_date", form.drivingStartDate.trim());
    appendIfPresent(applicationPayload, "months_active", form.monthsActive.trim());
    appendIfPresent(applicationPayload, "trip_acceptance_rate", form.rideAcceptanceRate.trim());
    appendIfPresent(applicationPayload, "cancellation_rate", form.cancellationRate.trim());
    appendIfPresent(
      applicationPayload,
      "average_number_of_trips_per_week",
      form.averageWeeklyTrips.trim(),
    );
    appendIfPresent(
      applicationPayload,
      "vehicle_type",
      vehicleTypeByVehicleRequested[form.vehicleRequested],
    );
    appendIfPresent(applicationPayload, "preferred_vehicle_make", form.preferredMakeModel.trim());
    appendIfPresent(
      applicationPayload,
      "preferred_vehicle_color",
      form.preferredVehicleColor.trim(),
    );
    appendIfPresent(applicationPayload, "repayment_preference", form.repaymentPreference.trim());
    appendIfPresent(applicationPayload, "national_id_number", form.nationalIdNumber.trim());
    appendIfPresent(
      applicationPayload,
      "drivers_license_number",
      form.driverLicenseNumber.trim(),
    );
    appendIfPresent(
      applicationPayload,
      "drivers_license_expiration_date",
      form.licenseExpiryDate.trim(),
    );
    appendIfPresent(
      applicationPayload,
      "criminal_record_certificate_reference_number",
      form.moralityCertificateReference.trim(),
    );
    appendIfPresent(applicationPayload, "guarantor_name", form.guarantorFullName.trim());
    appendIfPresent(
      applicationPayload,
      "guarantor_relationship",
      form.guarantorRelationship.trim(),
    );
    appendIfPresent(
      applicationPayload,
      "guarantor_phone_number",
      form.guarantorPhoneNumber.trim(),
    );
    appendIfPresent(applicationPayload, "guarantor_id_number", form.guarantorNationalId.trim());
    appendIfPresent(applicationPayload, "guarantor_address", form.guarantorAddress.trim());

    documentTypes
      .map((item) => ({ item, file: documentFiles[item.id] }))
      .filter((entry) => Boolean(entry.file))
      .forEach((entry, index) => {
        applicationPayload.append(`documents[${index}][image]`, entry.file);
        applicationPayload.append(`documents[${index}][document_type_id]`, entry.item.id);
      });

    dispatch(showLoader(t("mplus.loader.submitting")));

    try {
      await DriverApi.createVehicleLeasePurchase(applicationPayload);
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: t("mplus.success.message"),
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
          variant: "success",
        }),
      );
      navigate("/login");
    } catch (error) {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message:
            error?.response?.data?.error ||
            error?.response?.data?.message ||
            t("mplus.error.submitFailed"),
          autoHideDuration: 4000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
          variant: "error",
        }),
      );
    }
  }

  const submitLabel = currentStep === 5 ? t("mplus.btn.submit") : t("mplus.btn.continue");

  return (
    <div className="driver-signup-page">
      <a className="driver-signup-skip" href="#main-content">
        {t("mplus.skipToMain")}
      </a>

      <Header />

      <main className="driver-signup-page__main" id="main-content">
        <div className="driver-signup-shell">

          <section className="driver-signup-card" aria-label={t("mplus.aria.driverSignup")}>
            <aside className="driver-signup-card__intro">
              <StepIntroPanel currentStep={currentStep} t={t} />
            </aside>

            <section className="driver-signup-card__form">
              <div className="driver-signup-form__stepper">
                <Stepper currentStep={currentStep} t={t} />
              </div>

              <form className="driver-signup-form" onSubmit={handleSubmit}>
                {currentStep === 1 ? (
                  <div className="driver-signup-form__section">
                    <h3 className="driver-signup-section__title">{t("mplus.section.candidateInfo")}</h3>
                    <p className="driver-signup-section__subtitle">
                      {t("mplus.section.candidateInfoSubtitle")}
                    </p>

                    <div className="driver-signup-field-group">
                      <LabeledInput
                        label={t("mplus.label.accountId")}
                        required
                        name="accountId"
                        value={form.accountId}
                        onChange={handleAccountIdChange}
                        onBlur={handleAccountIdBlur}
                        placeholder={t("mplus.placeholder.accountId")}
                        error={errors.accountId || codeLookupError}
                        autoComplete="off"
                        disabled={codeLookupLoading}
                        className="driver-signup-control--span-2"
                      />
                      <p className="driver-signup-field__hint">
                        {t("mplus.hint.accountId")}
                      </p>
                      {codeLookupLoading ? (
                        <div className="driver-signup-code-status driver-signup-code-status--loading">
                          <SpinnerIcon />
                          <span>{t("mplus.code.verifying")}</span>
                        </div>
                      ) : null}
                      {!codeLookupLoading && codeVerified ? (
                        <div className="driver-signup-code-status driver-signup-code-status--success">
                          <CheckIcon />
                          <span>{t("mplus.code.found", { name: form.fullName })}</span>
                        </div>
                      ) : null}
                      {!codeLookupLoading && codeLookupError ? (
                        <div className="driver-signup-code-status driver-signup-code-status--error">
                          <ErrorIcon />
                          <span>{codeLookupError}</span>
                        </div>
                      ) : null}
                    </div>

                    {codeVerified ? (
                      <>
                        <LabeledInput
                          label={t("mplus.label.fullName")}
                          required
                          name="fullName"
                          value={form.fullName}
                          onChange={updateField("fullName")}
                          placeholder={t("mplus.placeholder.fullName")}
                          error={errors.fullName}
                          autoComplete="name"
                          className="driver-signup-control--span-2"
                        />

                        <div className="driver-signup-grid driver-signup-grid--2">
                          <LabeledInput
                            label={t("mplus.label.phone")}
                            required
                            name="phone"
                            value={form.phone}
                            onChange={updateField("phone")}
                            placeholder={t("mplus.placeholder.phone")}
                            error={errors.phone}
                            autoComplete="tel"
                            inputMode="tel"
                          />

                          <LabeledInput
                            label={t("mplus.label.email")}
                            required
                            name="email"
                            value={form.email}
                            onChange={updateField("email")}
                            placeholder={t("mplus.placeholder.email")}
                            error={errors.email}
                            autoComplete="email"
                          />
                        </div>

                        <div className="driver-signup-grid driver-signup-grid--2">
                          <SelectField
                            label={t("mplus.label.region")}
                            required
                            name="region"
                            value={form.region}
                            onChange={updateField("region")}
                            error={errors.region}
                          >
                            <option value="" disabled>
                              {t("mplus.placeholder.select")}
                            </option>
                            {regionOptions.map((option) => (
                              <option key={option.value} value={option.value}>
                                {t(option.labelKey)}
                              </option>
                            ))}
                          </SelectField>

                          <LabeledInput
                            label={t("mplus.label.address")}
                            required
                            name="address"
                            value={form.address}
                            onChange={updateField("address")}
                            placeholder={t("mplus.placeholder.address")}
                            error={errors.address}
                          />
                        </div>
                      </>
                    ) : null}
                  </div>
                ) : null}

                {currentStep === 2 ? (
                  <div className="driver-signup-form__section">
                    <div className="driver-signup-section__header">
                      <span className="driver-signup-section__badge">02</span>
                      <h3 className="driver-signup-section__title">{t("mplus.section.drivingStatus")}</h3>
                    </div>

                    <div className="driver-signup-grid driver-signup-grid--2">
                      <LabeledInput
                        label={t("mplus.label.drivingStartDate")}
                        required
                        name="drivingStartDate"
                        value={form.drivingStartDate}
                        onChange={updateField("drivingStartDate")}
                        error={errors.drivingStartDate}
                        type="date"
                      />

                      <LabeledInput
                        label={t("mplus.label.monthsActive")}
                        required
                        name="monthsActive"
                        value={form.monthsActive}
                        onChange={updateField("monthsActive")}
                        placeholder={t("mplus.placeholder.monthsActive")}
                        error={errors.monthsActive}
                        inputMode="numeric"
                        type="number"
                      />

                      <div className="driver-signup-field-group">
                        <LabeledInput
                          label={t("mplus.label.rideAcceptanceRate")}
                          required
                          name="rideAcceptanceRate"
                          value={form.rideAcceptanceRate}
                          onChange={updateField("rideAcceptanceRate")}
                          placeholder={t("mplus.placeholder.rideAcceptanceRate")}
                          error={errors.rideAcceptanceRate}
                          inputMode="decimal"
                          type="number"
                        />
                        <p className="driver-signup-field__hint">
                          {t("mplus.hint.rideAcceptanceRate")}
                        </p>
                      </div>

                      <div className="driver-signup-field-group">
                        <LabeledInput
                          label={t("mplus.label.cancellationRate")}
                          required
                          name="cancellationRate"
                          value={form.cancellationRate}
                          onChange={updateField("cancellationRate")}
                          placeholder={t("mplus.placeholder.cancellationRate")}
                          error={errors.cancellationRate}
                          inputMode="decimal"
                          type="number"
                        />
                        <p className="driver-signup-field__hint">
                          {t("mplus.hint.cancellationRate")}
                        </p>
                      </div>

                      <LabeledInput
                        label={t("mplus.label.averageWeeklyTrips")}
                        required
                        name="averageWeeklyTrips"
                        value={form.averageWeeklyTrips}
                        onChange={updateField("averageWeeklyTrips")}
                        placeholder={t("mplus.placeholder.averageWeeklyTrips")}
                        error={errors.averageWeeklyTrips}
                        inputMode="numeric"
                        type="number"
                        className="driver-signup-control--span-2 driver-signup-control--compact"
                      />
                    </div>
                  </div>
                ) : null}

                {currentStep === 3 ? (
                  <>
                    <div className="driver-signup-form__section">
                      <div className="driver-signup-section__header">
                        <span className="driver-signup-section__badge">03</span>
                        <h3 className="driver-signup-section__title">{t("mplus.section.vehicleRequested")}</h3>
                      </div>

                      <div className="driver-signup-radio-row driver-signup-radio-row--compact">
                        {vehicleRequestOptions.map((option) => (
                          <RadioOption
                            key={option.value}
                            name="vehicleRequested"
                            value={option.value}
                            label={t(option.labelKey)}
                            icon={option.icon}
                            checked={form.vehicleRequested === option.value}
                            onChange={() => handleRadioChange("vehicleRequested", option.value)}
                          />
                        ))}
                      </div>
                      {errors.vehicleRequested ? (
                        <p className="driver-signup-error">{errors.vehicleRequested}</p>
                      ) : null}

                      <div className="driver-signup-grid driver-signup-grid--2">
                        <LabeledInput
                          label={t("mplus.label.preferredMakeModel")}
                          name="preferredMakeModel"
                          value={form.preferredMakeModel}
                          onChange={updateField("preferredMakeModel")}
                          placeholder={t("mplus.placeholder.preferredMakeModel")}
                          error={errors.preferredMakeModel}
                        />

                        <LabeledInput
                          label={t("mplus.label.preferredVehicleColor")}
                          name="preferredVehicleColor"
                          value={form.preferredVehicleColor}
                          onChange={updateField("preferredVehicleColor")}
                          placeholder={t("mplus.placeholder.preferredVehicleColor")}
                          error={errors.preferredVehicleColor}
                        />
                      </div>
                    </div>

                    <div className="driver-signup-divider" />

                    <div className="driver-signup-form__section">
                      <div className="driver-signup-section__header">
                        <span className="driver-signup-section__badge">04</span>
                        <h3 className="driver-signup-section__title">{t("mplus.section.repaymentPreference")}</h3>
                      </div>

                      <div className="driver-signup-choice-grid">
                        {repaymentOptions.map((option) => (
                          <ChoiceCard
                            key={option.value}
                            name="repaymentPreference"
                            value={option.value}
                            label={t(option.labelKey)}
                            icon={CalendarIcon}
                            checked={form.repaymentPreference === option.value}
                            onChange={() => handleRadioChange("repaymentPreference", option.value)}
                          />
                        ))}
                      </div>
                      {errors.repaymentPreference ? (
                        <p className="driver-signup-error">{errors.repaymentPreference}</p>
                      ) : null}
                    </div>

                    <div className="driver-signup-divider" />

                    <div className="driver-signup-form__section">
                      <div className="driver-signup-section__header">
                        <span className="driver-signup-section__badge">05</span>
                        <h3 className="driver-signup-section__title">{t("mplus.section.identification")}</h3>
                      </div>

                      <div className="driver-signup-grid driver-signup-grid--2">
                        <LabeledInput
                          label={t("mplus.label.nationalIdNumber")}
                          required
                          name="nationalIdNumber"
                          value={form.nationalIdNumber}
                          onChange={updateField("nationalIdNumber")}
                          placeholder={t("mplus.placeholder.nationalIdNumber")}
                          error={errors.nationalIdNumber}
                        />

                        <LabeledInput
                          label={t("mplus.label.driverLicenseNumber")}
                          required
                          name="driverLicenseNumber"
                          value={form.driverLicenseNumber}
                          onChange={updateField("driverLicenseNumber")}
                          placeholder={t("mplus.placeholder.driverLicenseNumber")}
                          error={errors.driverLicenseNumber}
                        />

                        <LabeledInput
                          label={t("mplus.label.licenseExpiryDate")}
                          required
                          name="licenseExpiryDate"
                          value={form.licenseExpiryDate}
                          onChange={updateField("licenseExpiryDate")}
                          placeholder="jj/mm/aaaa"
                          error={errors.licenseExpiryDate}
                          type="date"
                        />

                        <LabeledInput
                          label={t("mplus.label.moralityCertificateReference")}
                          name="moralityCertificateReference"
                          value={form.moralityCertificateReference}
                          onChange={updateField("moralityCertificateReference")}
                          placeholder={t("mplus.placeholder.moralityCertificateReference")}
                          error={errors.moralityCertificateReference}
                        />
                      </div>
                    </div>
                  </>
                ) : null}

                {currentStep === 4 ? (
                  <>
                    <div className="driver-signup-callout">
                      <InfoIcon />
                      <p>
                        {t("mplus.callout.guarantor")}
                      </p>
                    </div>

                    <div className="driver-signup-form__section">
                      <div className="driver-signup-section__header">
                        <span className="driver-signup-section__badge">06</span>
                        <h3 className="driver-signup-section__title">{t("mplus.section.guarantorInfo")}</h3>
                      </div>

                      <div className="driver-signup-grid driver-signup-grid--2">
                        <LabeledInput
                          label={t("mplus.label.guarantorFullName")}
                          required
                          name="guarantorFullName"
                          value={form.guarantorFullName}
                          onChange={updateField("guarantorFullName")}
                          placeholder={t("mplus.placeholder.guarantorFullName")}
                          error={errors.guarantorFullName}
                        />

                        <SelectField
                          label={t("mplus.label.guarantorRelationship")}
                          required
                          name="guarantorRelationship"
                          value={form.guarantorRelationship}
                          onChange={updateField("guarantorRelationship")}
                          error={errors.guarantorRelationship}
                        >
                          <option value="" disabled>
                            {t("mplus.placeholder.select")}
                          </option>
                          {relationshipOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                              {t(option.labelKey)}
                            </option>
                          ))}
                        </SelectField>

                        <LabeledInput
                          label={t("mplus.label.guarantorPhoneNumber")}
                          required
                          name="guarantorPhoneNumber"
                          value={form.guarantorPhoneNumber}
                          onChange={updateField("guarantorPhoneNumber")}
                          placeholder={t("mplus.placeholder.guarantorPhone")}
                          error={errors.guarantorPhoneNumber}
                        />

                        <LabeledInput
                          label={t("mplus.label.guarantorNationalId")}
                          required
                          name="guarantorNationalId"
                          value={form.guarantorNationalId}
                          onChange={updateField("guarantorNationalId")}
                          placeholder={t("mplus.placeholder.guarantorNationalId")}
                          error={errors.guarantorNationalId}
                        />

                        <LabeledInput
                          label={t("mplus.label.guarantorAddress")}
                          required
                          name="guarantorAddress"
                          value={form.guarantorAddress}
                          onChange={updateField("guarantorAddress")}
                          placeholder={t("mplus.placeholder.address")}
                          error={errors.guarantorAddress}
                          className="driver-signup-control--span-2"
                        />
                      </div>
                    </div>

                    <div className="driver-signup-divider" />

                    <div className="driver-signup-form__section">
                      <div className="driver-signup-section__header">
                        <span className="driver-signup-section__badge">07</span>
                        <h3 className="driver-signup-section__title">{t("mplus.section.documentUpload")}</h3>
                      </div>

                      <div className="driver-signup-upload-grid">
                        {documentTypesLoading ? (
                          <p className="driver-signup-section__subtitle">
                            {t("mplus.upload.loadingDocs")}
                          </p>
                        ) : null}

                        {!documentTypesLoading && documentTypes.length === 0 ? (
                          <p className="driver-signup-error">
                            {t("mplus.upload.errorLoadDocs")}
                          </p>
                        ) : null}

                        {documentTypes.map((item) => (
                          <FileUploadField
                            key={item.id}
                            label={item.documentType}
                            hint={t(documentUploadHintKey)}
                            name={`document-${item.id}`}
                            file={documentFiles[item.id]}
                            onChange={handleDocumentFileChange(item.id)}
                            error={uploadErrors[item.id] || errors[item.id]}
                            t={t}
                          />
                        ))}
                      </div>

                      <ChecklistBox
                        title={t("mplus.upload.checklistTitle")}
                        items={documentTypes.map((item) => ({
                          id: item.id,
                          label: item.documentType,
                        }))}
                        values={documentsChecklist}
                      />
                    </div>
                  </>
                ) : null}

                {currentStep === 5 ? (
                  <>
                    <div className="driver-signup-form__section">
                      <div className="driver-signup-section__header">
                        <span className="driver-signup-section__badge">08</span>
                        <h3 className="driver-signup-section__title">{t("mplus.section.verification")}</h3>
                      </div>
                      <p className="driver-signup-section__subtitle">
                        {t("mplus.section.verificationSubtitle")}
                      </p>

                      <SummaryPanel form={form} intl={intl} t={t} />
                    </div>

                    <div className="driver-signup-declaration driver-signup-declaration--highlight">
                      <strong>{t("mplus.declaration.title")}</strong>{" "}
                      {t("mplus.declaration.text")}
                    </div>

                    <label className="driver-signup-consent">
                      <input
                        type="checkbox"
                        checked={form.acceptDeclaration}
                        onChange={(event) =>
                          setForm((current) => ({
                            ...current,
                            acceptDeclaration: event.target.checked,
                          }))
                        }
                      />
                      <span className="driver-signup-consent__box" aria-hidden="true">
                        <CheckIcon />
                      </span>
                      <span className="driver-signup-consent__text">
                        {t("mplus.consent.text", { termsLink: <Link to="/terms-conditions">{t("mplus.consent.terms")}</Link> })}
                      </span>
                    </label>
                    {errors.acceptDeclaration ? (
                      <p className="driver-signup-error">{errors.acceptDeclaration}</p>
                    ) : null}
                  </>
                ) : null}

                <div className="driver-signup-actions">
                  {currentStep > 1 ? (
                    <button type="button" className="driver-signup-back" onClick={goBack}>
                      <ArrowLeftIcon />
                      {t("mplus.btn.back")}
                    </button>
                  ) : (
                    <span />
                  )}

                  {currentStep === 5 ? (
                    <button type="submit" className="driver-signup-primary">
                      {submitLabel}
                      <ArrowRightIcon />
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="driver-signup-primary"
                      onClick={goNext}
                      disabled={currentStep === 1 && !codeVerified}
                    >
                      {submitLabel}
                      <ArrowRightIcon />
                    </button>
                  )}
                </div>
              </form>
            </section>

          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
}

